import WebApiService from "@/services/webapi.service.js";
import Entita from "@/models/entita.model.js";


const state = {
    entita:[]
}

const getters = {

    getEntita: (state) => {      
        return state.entita;
    },

    getEntitaAsc: (state) =>{
        return state.entita.sort(function(a,b){
            const na = a.Descrizione.toUpperCase();
            const nb = b.Descrizione.toUpperCase();
            if(na < nb){
                return -1;
            }
            if(na > nb ){
                return 1;
            }
        });
    },

    getDescrizioneEntita: (state) => (codiceEntita) => {
        if(state.entita){
            let entita = state.siti.find(item => item.CodiceEntita === codiceEntita);

            if(entita){
                return entita.DescrizioneEntita ?? "-";
            }else{
                return "-";
            }
        }
        else{
            return "-";
        }
    }
}

const mutations = {
    setEntita: (state, entita) => {
        state.entita = entita;
    }
}

const actions = {

    getEntita: ({commit}, data) => {
        return WebApiService.get('entita/GetEntita', data.token).then(
            (data) => {
                if(data.StatusCode !== 200){
                    return [false, data.Message];
                }else{
                    commit("setEntita", data.Data.map(
                        o => { return Object.assign(new Entita(),o) }
                    ));
                    return [true, ""];
                }
            },
            error => {
                return [false,""];
            }
        )
        .catch(
            error => {return [false, ""]}
        );
    }
}

export default{
    namespeced: true,
    state,
    getters,
    mutations,
    actions
}